/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Add_NewInputs */

const vi_product_add_new = /** @type {(inputs: Product_Add_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm sản phẩm mới`)
};

/**

* @param {Product_Add_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_add_new = /** @type {((inputs?: Product_Add_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Add_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_add_new(inputs)
});